import { ColumnsType } from 'antd/lib/table';
import dayjs, { Dayjs } from 'dayjs';
import { MedVoxTask } from '../../../models/MedVox/MedVoxTask';
import styles from './style.module.css';

export const RANGE_PRESENT: {
  label: string;
  value: [Dayjs, Dayjs];
}[] = [
  { label: 'День', value: [dayjs().add(-1, 'd'), dayjs()] },
  { label: 'Неделя', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Месяц', value: [dayjs().add(-30, 'd'), dayjs()] },
];

export const COLUMNS: ColumnsType<MedVoxTask> = [
  {
    title: 'Телефон',
    dataIndex: 'phone',
    responsive: ['sm'],
    sorter: (a, b) => Number(a.phone) - Number(b.phone),
    align: 'center' as const,
  },
  {
    title: 'ФИО',
    dataIndex: 'surname',
    responsive: ['sm'],
    align: 'center' as const,
  },
  {
    title: 'Результаты',
    dataIndex: 'results',
    responsive: ['sm'],
    align: 'center' as const,
  },

  {
    title: 'Статус',
    dataIndex: 'status',
    responsive: ['sm'],
    align: 'center' as const,
  },
  {
    title: 'Время',
    dataIndex: 'lastTime',
    responsive: ['sm'],
    align: 'center' as const,
  },
  {
    title: '№',
    dataIndex: 'id',
    sorter: (a, b) => Number(a.id) - Number(b.id),
    responsive: ['sm'],
    align: 'center' as const,
    render: (text) => <div className={styles.numberCell}>{text}</div>,
  },
];
